import { IUserDefinedInformationSource, IUserDefinedInformationSourceSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanUserDefinitionSelectable } from "../../../beans/objects";

export class UserDefinedInformationSourceTranslator {
  from(bean: IObjectBeanUserDefinitionSelectable): IUserDefinedInformationSource {
    return {
      fileName: bean["@source-file"],
    };
  }

  to(object: IUserDefinedInformationSourceSpecifiable) {
    return {
      sourceFile: object.userDefinedInformationSource.fileName,
    };
  }
}
